const renderChildren = ({ children, ...props }, renderDefaultChildren) => {
  // Prioritize children prop over children rendered based on props.
  if (children) {
    return typeof children === "function"
      ? children({
          ...props,
          // Allow children function to handle rendering the default children.
          renderChildren
        })
      : children
  }

  if (renderDefaultChildren) return renderDefaultChildren(props)
}

export default renderChildren
